import api from './index'

export function getProducts(params) {
  return api.get('/api/v1/products', { params })
}

export function getProductLabels() {
  return api.get('/api/v1/products/labels')
}

export function getProductBrands() {
  return api.get('/api/v1/products/brands')
}

export function getProductDetail(productCode, params = {}) {
  return api.get(`/api/v1/products/${encodeURIComponent(productCode)}`, { params })
}
